import React, { useEffect, useState } from 'react';
import YourImage from "../Assest/Pravin Badhe.webp"; 

const CoachIntroSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div
      style={{
        background: "linear-gradient(180deg, #000b3e 0, #020202 59%)",
        padding: "60px 20px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Outfit, sans-serif",
        color: "white",
        textAlign: "center",
      }}
    >

      {/* Left Side Image */}
      <div style={{ flex: "1 1 350px", maxWidth: "400px", margin: "20px" }}>
        <img
          src={YourImage}
          alt="Coach"
          style={{
            width: "100%",
            borderRadius: "1px",
            objectFit: "cover",
          }}
        />
      </div>

      {/* Right Side Text */}
      <div
        style={{
          flex: "1 1 400px",
          maxWidth: "600px",
          textAlign: "center",
          margin: "20px",
        }}
      >
        <h2 style={{ fontSize: "28px", fontWeight: "700", color: "#fff" }}>
          PRAVIN BADHE
        </h2>
        <h3 style={{ fontSize: "20px", fontWeight: "600", marginTop: "10px" }}>
          FOUNDER MEMBER AND MANAGING DIRECTOR 
        </h3>

        {/* Green underline */}
        <div
          style={{
            width: "60px",
            height: "4px",
            backgroundColor: "#2ecc71",
            margin: "20px auto",
            borderRadius: "4px",
          }}
        />

        <p style={{
          fontSize: "18px",
          lineHeight: "1.4",
          fontWeight: 500,
          textAlign: 'left',
          marginLeft:'10%'
        }}>
          With Over 25 Years of Experience in Debt Recovery, I Specialize in Strategic Planning, Risk Assessment, And 
          Performance Monitoring. I Lead High-Performing Teams, Collaborate With Finance, Legal, and Operations, and 
          Develop Effective Recovery Strategies. My Focus is on Optimizing Cash Flow, Minimizing Losses, and Building 
          Long-Term Partnerships With Banks and Financial Institutions. Through Data-Driven Insights and 
          Continuous Process Improvement, I Ensure Efficient Recoveries While Exploring New Business Opportunities for 
          Sustainable Growth in The Finance and Recovery Sector.
        </p>
      </div>
    </div>
  );
};

export default CoachIntroSection;